<template>
    <v-container fluid :class="getbMenuBlock ? 'layout-webview' : 'layout-browser'">
      <!-- Tabs de Pendientes y Finalizado -->
      <v-tabs 
        v-model="activeTab"
        rounded 
        height="40"
        class="tabs-estilo my-1"
        fixed-tabs
        :hide-slider="true">
        <v-tab 
          :class="{ 'tab-selected': activeTab === 0, 'tab-unselected': activeTab !== 0 }"
        > 
          {{ $STR.lblPendientes }}
          <v-chip class="ml-2" color="white" text-color="primary" small>{{ rondasPendientes.length }}</v-chip>
        </v-tab>
        <v-tab 
          :class="{ 'tab-selected': activeTab === 1, 'tab-unselected': activeTab !== 1 }"
        >
        {{ $STR.lblFinalizados }}
          <v-chip class="ml-2" color="white" text-color="primary" small>{{ rondasFinalizadas.length }}</v-chip>
        </v-tab>
      </v-tabs>

      <!-- Subitulos -->
      <v-row class="wrap_height_flex">
        <v-col>
          Hoy
        </v-col>
      </v-row>
      <v-row class="mt-1 wrap_height_flex">
        <v-col class="pt-1">
          <Buscador
            v-model="sFiltroBusqueda"
            :sPlaceholder="$STR.lblBuscarRondas"
            />
        </v-col>
      </v-row>
      <div v-if="rondasAMostrar.length > 0" class="scroll-container">
        <v-col class="pa-0 mb-2" cols="12" v-for="(ronda, index) in rondasAMostrar">
          <RondaItemCard
            :key="index"
            :oRonda="ronda"
            @onClickRonda="onClickRonda"
            @onRondaBloqueada="onRondaBloqueada"/>
        </v-col>
      </div>
      <InformacionSinActividades v-else 
        :sTitulo="$STR.msgRondasFinalizadas"
        :sDescripcion="$STR.msgSinRondasPendientes"
        :sImagen="'/img/icons/ic_sin_tareas_pendientes.svg'"
        />
      <DialogMensaje
        v-model="bDialog"
        :titulo="sTituloMensaje"
        :texto="sMensaje"
        :textoBtn="sTextoBtnAceptar"
        :bShowCancelar="bBtnCancelDialgo"
        @onAceptar="fAceptar"
        >
        <template v-slot:icono>
          <v-icon large color="red"> mdi-alert</v-icon>
        </template>
      </DialogMensaje>
    </v-container>
  </template>
  
  <script>
  import RondaItemCard from '@/components/control-actividades/rondas/RondaItemCard.vue'
  import InformacionSinActividades from '@/components/control-actividades/rondas/InformacionSinActividades.vue'
  import RondasRepository  from '@/views/control-actividades/rondas/RondasRepository.js'
  import DialogMensaje from '@/components/DialogMensaje.vue'
  import HoraFecha from "@/utils/Hora_Fecha.js"
  import Buscador from '@/components/Buscador.vue'
  import { mapGetters } from 'vuex'
  export default {
    name: 'DashboardRondas',
    components:{
      RondaItemCard,
      InformacionSinActividades,
      DialogMensaje,
      Buscador
    },
    data() {
      return {
        activeTab: 0,
        rondas: [],
        aRondas: [],
        oRondaEnProgreso: null,
        oRondaEnCompletada: {},
        oRondaCompletada: null,
        error: '',
        bDialog: false,
        bBtnCancelDialgo: false,
        sTituloMensaje: '',
        sMensaje: '',
        sTextoBtnAceptar: '',
        sFiltroBusqueda: null,
        fAceptar:()=>{},
      };
    },
    computed: {
      rondasPendientes() {
        return this.rondas.filter(ronda => !ronda.finalizado);
      },
      rondasFinalizadas() {
        return this.rondas.filter(ronda => ronda.finalizado);
      },
      rondasAMostrar() {
        const rondas = this.activeTab === 0 ? this.rondasPendientes : this.rondasFinalizadas;
        if (this.sFiltroBusqueda) {
          return rondas.filter(ronda => ronda.nombre.toLowerCase().includes(this.sFiltroBusqueda.toLowerCase()));
        }
        return rondas;
      },
      ...mapGetters(['getbMenuBlock']),
    },
    mounted() {
      this.$store.dispatch('setbNavegacion', false)
      this.onConsultarRondas()
    },
    methods: {
      onConsultarRondas(){
        this.rondas = RondasRepository.onGetRondas()
        this.rondas.forEach((oRonda)=>{
          if(oRonda.estado == "En progreso"){
            this.oRondaEnProgreso = oRonda
          }else if(oRonda.finalizado){
            this.$set(this.oRondaEnCompletada,oRonda.sIdActividad, { ...oRonda })
          }
        })
      },      
      onClickRonda(oRonda) {
        const sFechaActual = HoraFecha.getDia()
        
        if(this.oRondaEnProgreso !== null && this.oRondaEnProgreso.id !== oRonda.id){
          this.bDialog = true
          this.bBtnCancelDialgo = false
          this.sTituloMensaje = this.$STR.ttlRondaEnCurso
          this.sMensaje = this.$STR.msgRondaBloqueadaPorRondaEnProgreso
          this.sTextoBtnAceptar = this.$STR.btnAceptar
          this.fAceptar = () =>{}
          return 
        }

        if(this.oRondaEnCompletada !== null && this.activeTab === 0 && (oRonda.hora == 'Flexible')){
          const oRondaFinalizadaBase = this.oRondaEnCompletada[oRonda.sIdActividad]
          const nDiferenciaMinutos = HoraFecha.onGetDiferenciaEntreFechas(oRondaFinalizadaBase?.sFechaEjecucion, HoraFecha.getNow())
          if(nDiferenciaMinutos < parseInt(oRondaFinalizadaBase?.nIntervaloTiempoEjecucion)){
            this.bDialog = true
            this.bBtnCancelDialgo = false
            this.sTituloMensaje = this.$STR.ttlRondaBloqueada
            this.sMensaje = this.$STR.msgRondaBloqueadaEnEspera
            this.sTextoBtnAceptar = this.$STR.btnAceptar
            this.fAceptar = () =>{}
            return
          }
        }

        if(oRonda.hora != 'Flexible'){
          const sFechaHoraActual = `${sFechaActual} ${HoraFecha.getHora()}`
          const sfechaHoraInicio = `${sFechaActual} ${oRonda.hora}`
          if(this.activeTab === 0 && oRonda.estado == "Sin iniciar"){
            const nDiferencia = HoraFecha.onCompararFechaHora(sfechaHoraInicio, sFechaHoraActual)
            if(nDiferencia < 0){
              this.bDialog = true
              this.bBtnCancelDialgo = false
              this.sTituloMensaje = this.$STR.ttlRondaBloqueada
              this.sMensaje = this.$STR.msgRondaBloqueadaHoraInicio
              this.sTextoBtnAceptar = this.$STR.btnAceptar
              this.fAceptar = () =>{}
              return
            }
          }
        }

        if(oRonda.estado == "Bloqueado" && this.activeTab === 0){
          // Ronda Pendiente Bloqueada
          return
        }

        this.$store.dispatch('setbNavegacion', true)
        this.$router.push(`/PuntosPorRonda/${oRonda.id}`);
      },
      onRondaBloqueada() {
        this.bDialog = true
        this.bBtnCancelDialgo = false
        this.sTituloMensaje = this.$STR.ttlRondaBloqueada
        this.sMensaje = 'El punto leido no se encuentra asignado a esta ronda.'
        this.sTextoBtnAceptar = this.$STR.btnAceptar
        this.fAceptar = () =>{}
      },
      onOnBuscarDato(sTextoFiltro) {
        this.sFiltroBusqueda = sTextoFiltro;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  
  .v-list-item-content {
    font-size: 14px;
  }
  
  /* Estilo para el tab seleccionado */
  .tab-selected {
    background-color: #00A7C6 !important; /* Azul */
    color: #ffffff !important;
    border-radius: 23px !important; 
  }

  .tabs-unselected {
    background-color: #ffffff !important; /* Gris oscuro */
    color: #757575 !important;
    border-radius: 23px !important; 
  }
  
  /* Estilo para el tab no seleccionado */
  .tabs-estilo {
    background-color: #757575 !important; /* Gris oscuro */
    color: #757575 !important;
    border-radius: 23px !important;
    flex: 0;
  }
  .tabs-estilo::v-deep .v-slide-group__prev--disabled {
    display: none  !important;
  }
  
  .wrap-height {
    flex: 0;
  }

  </style>
  